import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface CustomTextFieldProps extends Omit<TextFieldProps, 'variant'> {
  variant?: 'default' | 'outlined';
  sx?: SxProps<Theme>;
}

const CustomTextField: React.FC<CustomTextFieldProps> = ({ 
  variant = 'default',
  sx,
  ...props 
}) => {
  const getSxStyles = () => {
    const baseStyles = {
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#f6f8f8',
        borderRadius: '12px',
        height: '56px',
        '& fieldset': {
          border: 'none'
        },
        '&:hover fieldset': {
          border: 'none'
        },
        '&.Mui-focused fieldset': {
          border: 'none'
        }
      },
      '& .MuiInputBase-input': {
        fontFamily: '"Inter", sans-serif',
        fontSize: '16px',
        color: (props as any).value ? '#181818' : '#93989c',
        '&::placeholder': {
          color: '#93989c',
          opacity: 1
        }
      }
    };

    // Merge with custom sx styles
    return sx ? { ...baseStyles, ...sx } : baseStyles;
  };

  return (
    <TextField
      {...props}
      sx={getSxStyles()}
    />
  );
};

export default CustomTextField;
